module.exports = __webpack_public_path__ + "static/media/tc.843bc6bb.jpg";